import { activateI18n } from '@retail/funnel-components';
import { messages as sellOnlyMessages } from '../translations/AH-sell-only/de/messages';
import { messages as retailMessages } from '../translations/autohero-common/de/messages';

activateI18n('de', {
  ...retailMessages,
  ...sellOnlyMessages,
});
